if (typeof localizationForm === 'undefined') {
    class LocalizationForm extends HTMLElement {
        constructor() {
            super();
            this.form = this.querySelector('form');
            this.input = this.querySelector('input[name="country_code"]');
            this.returnInput = this.form?.querySelector('input[name="return_to"]');
            this.currentCountry = this.dataset.currentCountry;
            this.currentLanguage = this.dataset.currentLanguage;
            this.currentCurrency = this.dataset.currentCurrency;
            this.englishFallback = this.dataset.englishFallback || 'US';
            this.storageKey = 'punkrave:last-english-country';
            this.currencyStorageKey = 'punkrave:last-english-currency';

            if (this.currentLanguage === 'en' && this.currentCountry !== 'DE') {
                this.writeStoredEnglishCountry(this.currentCountry);
                this.writeStoredEnglishCurrency(this.currentCurrency);
            }

            this.querySelectorAll('[data-language-target]').forEach((option) =>
                option.addEventListener('click', this.onLanguageClick.bind(this))
            );
        }

        readStoredEnglishCountry() {
            try {
                const value = window.localStorage.getItem(this.storageKey);
                return value && value !== 'DE' ? value : null;
            } catch (error) {
                return null;
            }
        }

        writeStoredEnglishCountry(countryCode) {
            try {
                window.localStorage.setItem(this.storageKey, countryCode);
            } catch (error) {
                // The selector still works when storage is unavailable.
            }
        }

        readStoredEnglishCurrency() {
            try {
                const value = window.localStorage.getItem(this.currencyStorageKey);
                return value && /^[A-Z]{3}$/.test(value) ? value : null;
            } catch (error) {
                return null;
            }
        }

        writeStoredEnglishCurrency(currencyCode) {
            if (!currencyCode || !/^[A-Z]{3}$/.test(currencyCode)) return;
            try {
                window.localStorage.setItem(this.currencyStorageKey, currencyCode);
            } catch (error) {
                // Language switching does not depend on persistent storage.
            }
        }

        syncCurrencyPreference(currencyCode) {
            if (!currencyCode || !/^[A-Z]{3}$/.test(currencyCode)) return;
            try {
                window.sessionStorage.setItem('buckscc_customer_currency', JSON.stringify(currencyCode));
                window.localStorage.setItem('buckscc_auto_currency', JSON.stringify({
                    currency: currencyCode,
                    timestamp: Date.now(),
                }));
            } catch (error) {
                // Shopify localization remains the source of truth if BUCKS storage is unavailable.
            }
        }

        onLanguageClick(event) {
            const targetLanguage = event.currentTarget.dataset.languageTarget;
            if (!targetLanguage) return;
            if (targetLanguage === this.currentLanguage) {
                event.preventDefault();
                return;
            }
            if (!this.form || !this.input) return;

            event.preventDefault();
            event.stopPropagation();

            if (targetLanguage === 'de') {
                if (this.currentCountry !== 'DE') {
                    this.writeStoredEnglishCountry(this.currentCountry);
                    this.writeStoredEnglishCurrency(this.currentCurrency);
                }
                this.input.value = 'DE';
                this.syncCurrencyPreference('EUR');
            } else {
                this.input.value = this.readStoredEnglishCountry() || this.englishFallback;
                this.syncCurrencyPreference(this.readStoredEnglishCurrency() || 'USD');
            }

            if (this.returnInput) {
                this.returnInput.value = window.location.pathname + window.location.search;
            }

            this.setAttribute('aria-busy', 'true');
            this.querySelectorAll('[data-language-target]').forEach((option) => {
                option.setAttribute('aria-disabled', 'true');
            });
            this.form.submit();
        }
    }

    customElements.define('localization-form', LocalizationForm);

    var localizationForm = LocalizationForm;
}
